export default __webpack_public_path__ + "btn-edit2.png?6de41c0e366d19bbee8ee1b5d98e791d";